module.exports = __webpack_public_path__ + "media/de_de_s1_Dietmar.e5b104f1.oga";